// 查询是否属于宁波区划
import { expenseWorkFlowKeyMap } from '@/components/WorkFlow/constants';
import { fetchPayConfig, getOrgExpenseBusinessConfig } from '@/services/config';
import { commonPlace } from '@/services/user';
import { queryWorkFlowInfo } from '@/services/workflow';
import { cloneDeep, get, omit, sortBy } from 'lodash';
import {
  zlbApiExpenseCommonDicFeeTypeTreeGetGet,
  zlbApiExpenseCommonDicGetPost,
} from 'src/api/zlbExpense';
import { reqAllCompanyInfo, reqCompanyInfo } from 'src/routes/Apply/services';
import {
  batchQueryInvoice,
  calculateShortDistance,
  deleteClaim,
  fetchBusinessConfig,
  fetchRejectWorkFlow,
  getClaimDetail,
  getClaimInfo,
  getDriverListForClaim,
  getMultiInvoiceConfig,
  getSingleBatchContractDetail,
  getTradeWay,
  getUserChannel,
  initFormBasicInfoTrip,
  judgeIsJXTenant,
  judgeIsZSPublicSafety,
  onOcrRealSave,
  queryClaimFormDefineByCode,
  queryClaimFormDefineByCodeFromCashier,
  queryContractRemainingAmount,
  reqFeeTypelList,
  reqInvoiceType,
  // reqPayMode,
  reqTrainTimeHour,
  reqZcyContractList,
  saveClaim,
  submitClaim,
  submitWorkFlow,
} from 'src/routes/Claim/services';
import { getOtherFundsDetail } from 'src/routes/OtherFundsOfTheUnit/services';
import { DEFAULT_EXPENSE_FEE } from '../config/constants';

const formatData = (data = []) => {
  return (data || [])?.map(i => ({
    label: i.name || i.typeName,
    value: i.code || i.typeCode,
    ...i,
    children: i.children && i.children.length > 0 ? formatData(i.children) : null,
  }));
};

export default {
  namespace: 'claim',
  state: {
    multiInvioceFeeTypeItem: {}, // 多票费用项
    companyInfo: {}, // 部门信息
    expenseType: [], // 出差类型
    entertainTypeList: [], // 招待形式
    feeTypelList: [], // 费用类型枚举
    trainHourList: [], // 火车时长枚举
    invoiceTypeList: [], // 发票类型
    allCompanyInfo: {},
    tradeWays: [], // 交易方式
    zcyContractData: {}, // 合同列表
    chooseBusinessType: undefined, // 选中的出差类型
    workFlowData: {}, // 工作流数据
    cacheWorkFlowInfo: {},
    payConfig: {}, // 支付方式
    startCityList: [], // 常用出发地
    endCityList: [], // 常用目的地
    feeTypeTree: [],
    feeTypeAll: {}, // 费用类型
    instanceInfoList: [],
    instanceCanSelectList: [],
    isNbDistrict: false, // 判断是否是宁波区划 ;已废弃，请从global中获取
    isZSPublicSafety: false, // 判断是否是舟山公安 ;已废弃，请从global中获取
    isJXTenant: false, // 判断是否是嘉兴租户 ;已废弃，请从global中获取
    isScDistrict: false, // 判断是否是上城区划 ;已废弃，请从global中获取
    collectiondetailControl: [],
    budgetControl: {}, // 预算指标、预算额度强弱控控制对象
    noticketFeeTypeTree: [],
    userChannel: [], // pc端票据使用方式
    refreshClaimDetail: () => {}, // 刷新详情
    listReload: () => {}, // 刷新列表
    multiInvoiceConfig: [], // 多票配置
    // 预算支付限额批量查询结果
    budgetRestrictionObj: [],
    showBudgetRestrictionValidateRes: false,
    // 需要 OCR 验真的票据（公共事业缴费）
    needsOCRAttachments: [],
    // 公共事业缴费 OCR 识别结果
    publicPaymentOCRRes: {},
    publicPaymentShowOcrInvoiceModal: false,
    BudgetProjectScenesConfigList: [],
    enableOtherFundsAudit: false, // 是否开启核算 true: 开启 false：关闭
    budgetConfigObj: {}, // 预算（指标/项目）配置信息
  },
  effects: {
    *updateBudgetProjectRecord({ payload }, { put }) {
      const { budgetProjectConfigList, ...rest } = payload || {};
      yield put({
        type: 'update',
        payload: {
          BudgetProjectScenesConfigList: budgetProjectConfigList,
          budgetConfigObj: rest,
        },
      });
    },
    *getMultiInvioceConfig({ payload }, { call, put }) {
      const result = yield call(getMultiInvoiceConfig, payload);
      yield put({
        type: 'update',
        payload: {
          multiInvoiceConfig: result || [],
        },
      });
    },

    *updateBudgetControl({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: {
          budgetControl: payload || {},
        },
      });
    },
    *deleteBudgetControl({ payload }, { put, select }) {
      if (Object.prototype.toString.call(payload) !== '[object Number]') return;
      const budgetControlClone = cloneDeep(yield select(state => state.claim.budgetControl));
      if (budgetControlClone?.[payload]) {
        yield put({
          type: 'update',
          payload: {
            budgetControl: omit(budgetControlClone, payload),
          },
        });
      }
    },
    *getCompanyList({ payload }, { call, put }) {
      const result = yield call(reqCompanyInfo, payload);
      const departmentList = result?.departmentList?.map(i => ({
        ...i,
        fullName: `${i.parentDeptName || result.orgName}${i.deptId === -1 ? '' : '-' + i.deptName}`,
      }));
      result.departmentList = departmentList;
      yield put({
        type: 'update',
        payload: {
          companyInfo: result || {},
        },
      });
    },
    *fetchExpenseType({ payload }, { call, put }) {
      const result = yield call(zlbApiExpenseCommonDicGetPost, payload);
      const { values } = result?.length && result[0];
      if (result?.[0]?.typeCode === 'FORM_BUSINESS_TYPE') {
        // 出差形式
        const travelTypes = (values || [])?.map(item => ({
          businessType: item.key,
          businessTypeName: item.desc,
        }));
        yield put({
          type: 'update',
          payload: {
            expenseType: travelTypes,
          },
        });
      }
      if (result?.[0]?.typeCode === 'MEAL_TYPE') {
        // 招待形式
        yield put({
          type: 'update',
          payload: {
            entertainTypeList: values,
          },
        });
      }
      return result;
    },
    *fetchFeeTypelList({ payload }, { call, put }) {
      const result = yield call(reqFeeTypelList, payload);
      yield put({
        type: 'update',
        payload: {
          feeTypelList: result || [],
        },
      });
    },

    *fetchTrainTimeHour({ payload }, { call, put }) {
      const result = yield call(reqTrainTimeHour, payload);
      yield put({
        type: 'update',
        payload: {
          trainHourList: result || [],
        },
      });
    },

    *fetchInvoiceType({ payload }, { call, put }) {
      const result = yield call(reqInvoiceType, payload);
      yield put({
        type: 'update',
        payload: {
          invoiceTypeList: result || [],
        },
      });
    },

    // 报销单获取工作流详情
    *getWorkFlowInfo({ payload }, { call }) {
      return yield call(queryWorkFlowInfo, payload);
    },

    // 获取工作流详情
    *getWorkFlowInfoByEdit({ payload }, { call, put, select }) {
      const result = yield call(queryWorkFlowInfo, payload);
      const cacheWorkFlowInfo = yield select(state => state.claim.cacheWorkFlowInfo);
      // 根据工作流的key建立独立的队列 队列长度10
      cacheWorkFlowInfo[payload.workflowProcessKey] =
        cacheWorkFlowInfo[payload.workflowProcessKey] || {};
      const keyMap = cacheWorkFlowInfo[payload.workflowProcessKey];
      keyMap[new Date().getTime()] = result;

      const keysArr = sortBy(Object.keys(keyMap));
      if (keysArr.length > 5) {
        Reflect.deleteProperty(keyMap, keysArr[0]);
      }
      const valueArr = keysArr?.map(i => keyMap[i]);
      const lastestResult = valueArr[valueArr.length - 1];
      yield put({
        type: 'update',
        payload: {
          workFlowData: lastestResult || {},
          cacheWorkFlowInfo,
        },
      });
      return lastestResult;
    },

    // 本单位下所有部门信息查询
    *getAllCompanyList({ payload }, { call, put }) {
      const result = yield call(reqAllCompanyInfo, payload);
      const departmentList = result.departmentInfoDtoList?.map(i => ({
        ...i,
        deptId: i.departmentId,
        fullName: `${result.institutionName} ${
          i.departmentId === -1 ? '' : '- ' + i.departmentName
        }`,
      }));
      result.departmentList = departmentList;
      yield put({
        type: 'update',
        payload: {
          allCompanyInfo: result || {},
        },
      });
    },

    // 计算短途包干费用
    *calculateShortDistance({ payload }, { call }) {
      return yield call(calculateShortDistance, payload);
    },
    // 获取驳回历史
    *getRejectWorkFlow({ payload }, { call }) {
      return yield call(fetchRejectWorkFlow, payload);
    },

    // 获取报销单支付方式
    // * getPayMode ({ payload }, { call, put }) {
    //   return yield call(reqPayMode, payload);
    // },

    // 发票验真新
    *onOcrRealSave({ payload }, { call }) {
      try {
        return yield call(onOcrRealSave, payload);
      } catch (error) {
        // 超时处理
        console.log('onOcrRealSave-catch', error);
      }
    },
    // 获取交易方式
    *getTradeWay({ payload }, { call, put }) {
      const result = yield call(getTradeWay, payload);
      yield put({
        type: 'update',
        payload: {
          tradeWays: formatData(result) || [],
        },
      });
    },
    // 获取合同剩余金额
    *getContractRemainingAmount({ payload }, { call }) {
      return yield call(queryContractRemainingAmount, payload);
    },
    // 获取单个合同详情-zcy
    *getSingleBatchContractDetail({ payload }, { call }) {
      return yield call(getSingleBatchContractDetail, payload);
    },

    // 生成报销单
    *initFormBasicInfoTrip({ payload }, { call }) {
      return yield call(initFormBasicInfoTrip, payload);
    },
    // 获取报销单详情
    *getClaimInfo({ payload }, { call, put }) {
      const result = yield call(getClaimInfo, payload);
      yield put({
        type: 'update',
        payload: {
          chooseBusinessType: result.businessType || '',
        },
      });
      return result;
    },
    // 获取报销单详情
    *getClaimDetail({ payload }, { call, put }) {
      const { reimburseBusinessType } = payload;
      let result = {};
      // 其它资金逻辑
      if (reimburseBusinessType === 'rest_form') {
        const { expenseFormCode, ...rest } = payload;
        const params = {
          formCode: expenseFormCode,
          ...rest,
        };
        result = yield call(getOtherFundsDetail, params);
      } else {
        result = yield call(getClaimDetail, payload);
      }
      yield put({
        type: 'update',
        payload: {
          chooseBusinessType: result.businessType || '',
        },
      });
      return result;
    },
    // 根据业务code获取单据详情
    *queryClaimFormDefineByCode({ payload }, { call, put }) {
      const { claimFormInfo, claimFormType } = payload;
      const params = {};
      params[7] = {
        code: 'zcy.baida.queryFormDefineByExpense',
        param: {
          getWorkflowInfo: {
            workflowProcessKey: expenseWorkFlowKeyMap[7],
            formType: 2,
          },
          getExpenseFormInfo: {
            ...claimFormInfo,
          },
          getFormInfo: {
            bizCode: payload.claimFormInfo.expenseFormCode,
          },
        },
      };
      const res = yield call(queryClaimFormDefineByCode, {
        ...params[claimFormType],
      });

      const { result } = res.result;

      yield put({
        type: 'update',
        payload: {
          chooseBusinessType: result?.expenseFormInfo?.businessType || '',
        },
      });
      return result;
    },
    // 根据业务code获取单据详情 - 出纳结算用
    *queryClaimFormDefineByCodeFromCashier({ payload }, { call }) {
      const { claimFormInfo, claimFormType } = payload;
      const params = {};
      params[7] = {
        code: 'zcy.baida.getFormDefineByExpense',
        param: {
          getWorkflowInfo: {
            workflowProcessKey: expenseWorkFlowKeyMap[7],
            formType: 2,
          },
          getInfoOnCashier: {
            ...claimFormInfo,
          },
          getFormInfo: {
            bizCode: payload.claimFormInfo.expenseFormCode,
          },
        },
      };
      const res = yield call(queryClaimFormDefineByCodeFromCashier, {
        ...params[claimFormType],
      });

      const { result } = res.result;
      return result;
    },

    // 保存报销单
    *saveClaim({ payload }, { call }) {
      return yield call(saveClaim, payload);
    },
    // 提交报销单
    *submitClaim({ payload }, { call }) {
      return yield call(submitClaim, payload);
    },
    // 删除报销单
    *deleteClaim({ payload }, { call }) {
      return yield call(deleteClaim, payload);
    },
    // 提交工作流
    *submitWorkFlow({ payload }, { call }) {
      return yield call(submitWorkFlow, payload);
    },
    *batchQueryInvoice({ payload }, { call }) {
      return yield call(batchQueryInvoice, payload);
    },
    // 从政采云导入合同
    *getZcyContractList({ payload }, { call, put }) {
      const result = yield call(reqZcyContractList, payload);
      yield put({
        type: 'update',
        payload: {
          zcyContractData: result.result || {},
        },
      });
      return result;
    },
    // 获取支付配置信息
    // TODO 下个版本 后端会添加字段
    *fetchPayConfig({ payload }, { call, put }) {
      const result = yield call(fetchPayConfig, payload);
      const { payConfig } = result.result || {};
      const payList = (get(payConfig, '[0].item') || [])?.filter(i => i.isEnable);

      const enableAudit = get(
        payList?.find(v => v.channelCode === 3),
        'enableAudit',
      );

      // 国库支付对应的支付方式
      const payConfigList =
        get(
          payList?.find(v => [1, 6].includes(v.channelCode)),
          'payTypes',
        ) || [];
      // CBS:5 也支持多收款人 ，但不需要预算数据
      // 第三方支付：8 支持多收款人
      const hasCBSPayMode =
        payList?.map(v => v.channelCode)?.some(i => [5, 8].includes(i)) || false;
      // 当前配置存在多选选项
      const isMultiReceiver =
        payConfigList?.some(v => v.isMultiReceiver && v.isCheck) || hasCBSPayMode; // 可选择多收款人
      const isMultiBudget = payConfigList?.some(v => v.isMultiBudget && v.isCheck); // 可选择多条预算
      // 支持混合支付
      const isEnableSuplier = get(
        payConfigList?.find(v => v.payType === 14),
        'isCheck',
      );
      // 是否开启单位资金: 2
      const hasUnitFundPayMode = payList?.some(i => i.channelCode === 2) || false;
      yield put({
        type: 'update',
        payload: {
          payConfig: {
            isMultiReceiver,
            // 调批量发放对公，临时调整为多预算
            isMultiBudget,
            isEnableSuplier,
            hasUnitFundPayMode,
          },
          enableOtherFundsAudit: enableAudit || false,
        },
      });
      return result;
    },
    *getCommonPlace({ payload }, { call, put }) {
      const { cityType } = payload;
      const result = yield call(commonPlace, payload);
      yield put({
        type: 'update',
        payload:
          cityType === 1
            ? {
                startCityList: result || [],
              }
            : {
                endCityList: result || [],
              },
      });
      return result;
    },
    *getDriverListForClaim({ payload }, { call }) {
      return yield call(getDriverListForClaim, payload);
    },
    *getFeeTypeTree({ payload }, { call, put }) {
      const result = yield call(zlbApiExpenseCommonDicFeeTypeTreeGetGet, payload);
      yield put({
        type: 'update',
        payload: {
          feeTypeTree: result || [],
        },
      });
    },
    *getFeeTypeAll({ payload }, { call, put }) {
      const result = yield call(zlbApiExpenseCommonDicFeeTypeTreeGetGet, payload);
      const feeTypeAll = {};
      Object.keys(DEFAULT_EXPENSE_FEE)?.forEach(k => {
        result?.forEach(v => {
          // 匹配接口返回的费用类型，生成要展示的费用信息
          if (v.value === DEFAULT_EXPENSE_FEE[k]?.feeParentType) {
            feeTypeAll[k] = DEFAULT_EXPENSE_FEE[k];
            feeTypeAll[k].feeParentTypeDesc = v.parentFeeShowLabel;
          }
        });
      });
      yield put({
        type: 'update',
        payload: {
          feeTypeAll,
        },
      });
    },
    *updateNbPayConfig({ payload }, { call, put, select }) {
      const isDistrictReady = cloneDeep(
        yield select(state => state?.global?.isDistrictReady || false),
      );
      if (!isDistrictReady) {
        return;
      }
      const isMultiReceiver = cloneDeep(
        yield select(state => state?.payConfig?.isMultiReceiver || false),
      );
      const isNbDistrict = cloneDeep(yield select(state => state?.global?.isNbDistrict || false));
      yield put({
        type: 'update',
        payload: {
          payConfig: {
            isMultiReceiver: isNbDistrict || isMultiReceiver,
          },
        },
      });
      if (payload?.timer) {
        clearInterval(payload.timer);
      }
    },
    /**
     * 判断是否嘉兴租户
     */
    *judgeIsJXTenant({ payload }, { call, put }) {
      const result = yield call(judgeIsJXTenant, payload);
      yield put({
        type: 'update',
        payload: {
          isJXTenant: result || false,
        },
      });
    },
    /**
     * 判断是否舟山公安
     */
    *judgeIsZSPublicSafety({ payload }, { call, put }) {
      const result = yield call(judgeIsZSPublicSafety, payload);
      yield put({
        type: 'update',
        payload: {
          isZSPublicSafety: result || false,
        },
      });
    },
    /**
     * 判断是否上城
     */
    *fetchBusinessConfig({ payload }, { call, put }) {
      const result = yield call(fetchBusinessConfig, payload);
      const { isScDistrict } = result;
      yield put({
        type: 'update',
        payload: {
          isScDistrict: isScDistrict === 'true' || false,
        },
      });
    },
    /**
     * 给收款明细增加强弱控信息
     * @param {*} param0
     * @returns
     */
    *updateCollectionDetailControl({ payload }, { put }) {
      if (!Array.isArray(payload)) return;
      const control = cloneDeep(payload);
      yield put({
        type: 'update',
        payload: {
          collectiondetailControl: control || [],
        },
      });
    },
    /**
     * 票据配置信息
     */
    *getUserChannel({ payload }, { call, put }) {
      const res = yield call(getUserChannel, payload);
      yield put({
        type: 'update',
        payload: {
          userChannel: res?.find(ele => ele.useChannelId === 2)?.uploadModeIdList || [],
        },
      });
    },
    // 查询单位业务配置
    *getOrgExpenseBusinessConfig({ payload }, { call, put }) {
      const res = yield call(getOrgExpenseBusinessConfig, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
    initCallBack(state) {
      return {
        ...state,
        refreshClaimDetail: () => {}, // 刷新详情
        listReload: () => {}, // 刷新列表
      };
    },
  },
  subscriptions: {
    setupHistory({ dispatch, history }) {
      history.listen(location => {
        const pathname = location.pathname;
        // 我的单据/审批单据/出纳结算/单据管理
        if (
          pathname.includes('/my-document/list') ||
          pathname.includes('/approval-document/list') ||
          pathname.includes('cashier-document/list') ||
          pathname.includes('finance-document/list')
        ) {
          // 如果是刷新进入该页面，则定时查询区划请求结果
          if (history?.action === 'POP') {
            const timer = setInterval(() => {
              dispatch({
                type: 'updateNbPayConfig',
                payload: {
                  timer,
                },
              });
            }, 1000);
          } else {
            // 切换路由进入页面
            dispatch({
              type: 'updateNbPayConfig',
            });
          }
        }
      });
    },
  },
};
